import ExcelJS from 'exceljs'

export function exportCustomerPerformance(data) {

    const workbook = new ExcelJS.Workbook()

    const worksheet =
        workbook.addWorksheet(
            '顾客业绩区间表'
        )

    // =====================
    // 冻结表头
    // =====================

    worksheet.views = [
        {
            state: 'frozen',
            ySplit: 2
        }
    ]

    // =====================
    // 合并表头
    // =====================

    worksheet.mergeCells('A1:A2')

    worksheet.mergeCells('B1:D1')
    worksheet.mergeCells('E1:G1')
    worksheet.mergeCells('H1:J1')
    worksheet.mergeCells('K1:M1')
    worksheet.mergeCells('N1:P1')
    worksheet.mergeCells('Q1:S1')
    worksheet.mergeCells('T1:U1')

    worksheet.getCell('A1').value = '公司'

    worksheet.getCell('B1').value = '0-1万'
    worksheet.getCell('E1').value = '1-3万'
    worksheet.getCell('H1').value = '3-5万'
    worksheet.getCell('K1').value = '5-10万'
    worksheet.getCell('N1').value = '10-20万'
    worksheet.getCell('Q1').value = '20万以上'
    worksheet.getCell('T1').value = '合计'

    worksheet.getRow(2).values = [

        '',

        '人数', '业绩', '业绩占比',

        '人数', '业绩', '业绩占比',

        '人数', '业绩', '业绩占比',

        '人数', '业绩', '业绩占比',

        '人数', '业绩', '业绩占比',

        '人数', '业绩', '业绩占比',

        '人数', '业绩'

    ]

    // =====================
    // 数据
    // =====================

    let rowIndex = 3

    data.forEach(item => {

        worksheet.getRow(rowIndex).values = [

            item.companyName,

            item.r0_1.count,
            item.r0_1.amount,
            item.r0_1.rate,

            item.r1_3.count,
            item.r1_3.amount,
            item.r1_3.rate,

            item.r3_5.count,
            item.r3_5.amount,
            item.r3_5.rate,

            item.r5_10.count,
            item.r5_10.amount,
            item.r5_10.rate,

            item.r10_20.count,
            item.r10_20.amount,
            item.r10_20.rate,

            item.gt20.count,
            item.gt20.amount,
            item.gt20.rate,

            item.total.count,
            item.total.amount

        ]

        rowIndex++

    })

    // =====================
    // 表头样式
    // =====================

    for (let i = 1; i <= 2; i++) {

        worksheet.getRow(i).eachCell(cell => {

            cell.font = {
                bold: true,
                color: {
                    argb: 'FFFFFF'
                },
                size: 12
            }

            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {
                    argb: 'C00000'
                }
            }

            cell.alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }

            cell.border = {

                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }

            }

        })

    }

    // =====================
    // 行高
    // =====================

    worksheet.getRow(1).height = 32
    worksheet.getRow(2).height = 28

    for (
        let i = 3;
        i <= worksheet.rowCount;
        i++
    ) {

        worksheet.getRow(i).height = 24

    }

    // =====================
    // 全表样式
    // =====================

    worksheet.eachRow(row => {

        row.eachCell(cell => {

            cell.border = {

                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }

            }

            cell.alignment = {

                horizontal: 'center',

                vertical: 'middle'

            }

        })

    })

    // =====================
    // 金额格式
    // =====================

    for (
        let row = 3;
        row <= worksheet.rowCount;
        row++
    ) {

        const moneyColumns = [

            3,
            6,
            9,
            12,
            15,
            18,
            21

        ]

        moneyColumns.forEach(col => {

            worksheet.getCell(
                row,
                col
            ).numFmt =
                '#,##0.00'

        })

    }

    // =====================
    // 总计行高亮
    // =====================

    const totalRow =

        worksheet.getRow(
            worksheet.rowCount
        )

    totalRow.eachCell(cell => {

        cell.font = {

            bold: true,

            size: 12

        }

        cell.alignment = {

            horizontal: 'center',

            vertical: 'middle'

        }

        cell.fill = {

            type: 'pattern',

            pattern: 'solid',

            fgColor: {
                argb: 'FFF2CC'
            }

        }

    })

    // =====================
    // 列宽
    // =====================

    worksheet.getColumn(1).width = 20

    for (
        let i = 2;
        i <= 21;
        i++
    ) {

        worksheet.getColumn(i).width = 14

    }

    // =====================
    // 导出
    // =====================

    workbook.xlsx
        .writeBuffer()
        .then(buffer => {

            const blob =

                new Blob(
                    [buffer],
                    {
                        type:
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                )

            const link =
                document.createElement('a')

            link.href =
                URL.createObjectURL(
                    blob
                )

            link.download =
                '顾客业绩区间表.xlsx'

            link.click()

        })

}